import { request } from '@/libs/api-request'
import { BEUSABLY_URL, getS3Url } from '@/libs/utils'

export function getReportPeriod (aid) {
  const config = {
    method: 'get',
    url: `/calendar/get_range/${aid}`
  }

  return request(config).then(data => {
    return data
  })
}

export function getReportPeriodByAbTest (aid) {
  const config = {
    method: 'get',
    url: `/calendar/get_range/by_abtest/${aid}`
  }

  return request(config).then(data => {
    return data
  })
}

export function getCaptureImageUrl (params, timestamp) {
  const config = {
    method: 'post',
    url: '/coords/get_image_path',
    data: params
  }

  // do not use cache
  return request(config, true).then(data => {
    if (data && data.imagePath) {
      return getS3Url(data.imagePath, timestamp)
    }
    return null
  })
}

export function getAvgFoldData (params) {
  const config = {
    method: 'post',
    url: '/es/get_average_fold',
    data: params
  }

  return request(config).then(data => {
    const avgFold = data[params.device]

    if (avgFold) {
      return { avgFold }
    }
    return null
  })
}

export function getHeatmapData (params) {
  const config = {
    method: 'post',
    url: '/es/get_heatmap_by_event',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getCoordsData (params) {
  const config = {
    method: 'post',
    url: '/coords/get_coords_data_by_abtext',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getSwipeData (params) {
  const config = {
    method: 'post',
    url: '/es/get_swipe',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getScrollData (params) {
  const config = {
    method: 'post',
    url: '/es/get_scroll',
    data: params
  }

  return request(config)
}

export function getBasicInfoData (params) {
  const config = {
    method: 'post',
    url: '/es/get_basic_info',
    data: params
  }

  return request(config)
}

export function getStreamPathData (params) {
  const config = {
    method: 'post',
    url: '/es/get_path',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message.toLowerCase() === 'no stream found') {
      return null
    }
    throw err
  })
}

export function getAnalyticsData (params) {
  const config = {
    method: 'post',
    url: '/es/get_analytics',
    data: params
  }

  return request(config)
}

export function getDailyDevice (params) {
  const config = {
    method: 'post',
    url: '/es/get_daily_device',
    data: params
  }

  return request(config)
}

export function getCtaData (params) {
  const config = {
    method: 'post',
    url: '/es/get_cta',
    data: params
  }

  return request(config)
}

export function getUtm (params) {
  const config = {
    method: 'post',
    url: '/es/get_utm',
    data: params
  }

  return request(config)
}

export function getUtid (sid) {
  const config = {
    method: 'get',
    url: `/ut/get_all?sid=${sid}`
  }

  return request(config)
}

export function getCid (params) {
  const config = {
    method: 'post',
    url: '/es/get_cid',
    data: params
  }

  return request(config)
}

export function getChannel (params) {
  const config = {
    method: 'post',
    url: '/es/get_utm',
    data: params
  }

  return request(config)
}

export function getHeatmapImage (params) {
  const config = {
    method: 'post',
    url: `${BEUSABLY_URL}/viewer/beusable_capture`,
    data: params
  }

  return request(config)
}

export function getHourBasicInfoData (params) {
  const config = {
    method: 'post',
    url: `/es/get_hour_basic_info`,
    data: params
  }

  return request(config)
}

export function getFreqInfoData (params) {
  const config = {
    method: 'post',
    url: `/es/get_freq_info`,
    data: params
  }

  return request(config)
}
